import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _create_class from "@swc/helpers/src/_create_class.mjs";
var PageAttributesOrganizer = /*#__PURE__*/ function() {
    "use strict";
    function PageAttributesOrganizer(attributes) {
        _class_call_check(this, PageAttributesOrganizer);
        this.attributes = attributes;
    }
    _create_class(PageAttributesOrganizer, [
        {
            key: "available",
            get: function get() {
                return this.ordered.filter(function(entity) {
                    return !!entity;
                });
            }
        },
        {
            key: "ordered",
            get: function get() {
                var _attributes = this.attributes, cityDistrict = _attributes.cityDistrict, airport = _attributes.airport, railStation = _attributes.railStation, city = _attributes.city, island = _attributes.island, state = _attributes.state, country = _attributes.country, bookingAttributes = _attributes.bookingAttributes, category = _attributes.category, partners = _attributes.partners;
                return [
                    partners ? partners[0] : null,
                    cityDistrict,
                    airport,
                    railStation,
                    city,
                    island,
                    state,
                    country,
                    bookingAttributes ? bookingAttributes[0] : null,
                    category, 
                ];
            }
        },
        {
            key: "primary",
            get: function get() {
                return this.available.length > 0 ? this.available[0] : null;
            }
        },
        {
            key: "secondary",
            get: function get() {
                return this.available.length > 1 ? this.available[1] : null;
            }
        }
    ]);
    return PageAttributesOrganizer;
}();
export { PageAttributesOrganizer };
